import React from 'react';
import styled from 'styled-components'
import { Link } from 'react-router-dom';
import CompanyPageTitle from 'containers/CompanyContainer/CompanyPageTitle';

const CompanyHeaderWrapper = styled.div`
    width: 100%;
    display: flex;
    padding: 4% 8% 6% 8%;
    height: 20vh;
    background: white;
`;
const LogoWrapper = styled.img`
    width: 220px;
    height: 220px;
    border-radius: 50%;
    box-shadow: -8px 8px 3px lightgrey;
`;
const TitleWrapper = styled.h2`
    margin-left: 2%;
    font-size: 35px;
    color: #71aec1;
`;
const LinkWrapper = styled(Link)`
    margin-left: 1%;
    text-decoration: none;
    padding: 1em 1.5em;
    border-radius: 10px;
    border: 1px solid lightgray;
    height: 15px;
    color: lightgray;
    font-weight: bold;
    letter-spacing: 0.5px;
`;

const CompanyHeader = ({ logo, title, isAdmin } ) => {

    return(
        <CompanyHeaderWrapper>
            
            {/* <CompanyPageTitle THESE PAGE TITLES WERE JUST FOR THE MOCKUPS
                label={'Company admin/staff dashboard'}
                type={'main'}
            /> */}
            <LogoWrapper src={logo}/>
            <TitleWrapper >{title}</TitleWrapper>
            { isAdmin &&
                <LinkWrapper to={`/company/companyEditor`}> Edit </LinkWrapper>
            }
        </CompanyHeaderWrapper>
    )
}

export default CompanyHeader;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/CompanyHeader.jsx